module.exports = __webpack_public_path__ + "static/media/yello.0fc5e443.svg";